import React from 'react';
import { Radio, RadioGroup, Card, TextArea } from 'elmo-elements';
import { ButtonWrapper, StyledButton, Error, StyledTextArea } from '../style';

import { ITMSLoginReason } from '../view';

const ReasonForm: React.FC<ITMSLoginReason> = ({
  handleSelect,
  isTextAreaDisplayed,
  submitEnabled,
  handleTextChange,
  otherText,
  handleSubmit,
  error,
}: ITMSLoginReason) => (
  <form onSubmit={handleSubmit}>
    <Card>
      <RadioGroup direction="vertical" onChange={handleSelect}>
        <Radio value="investigate">Investigate Client Inquiries</Radio>
        <Radio value="implementation">Implementation</Radio>
        <Radio value="train">ELMO Academy Training</Radio>
        <Radio value="test">Product Testing</Radio>
        <Radio value="healthcheck">Client Health Checks</Radio>
        <Radio value="adhocproject">Adhoc Technical Projects</Radio>
        <Radio value="demo">Product Demo</Radio>
        <Radio value="research">UX/UI Research</Radio>
        <Radio value="other">Other</Radio>
      </RadioGroup>
    </Card>
    {isTextAreaDisplayed && (
      <StyledTextArea>
        <TextArea
          value={otherText}
          placeholder="Please type the reason here..."
          name="textArea"
          onChange={handleTextChange}
        />
      </StyledTextArea>
    )}
    {error.length > 0 && <Error>{error}</Error>}
    <ButtonWrapper>
      <StyledButton
        type="primary"
        htmlType="submit"
        isDisabled={!submitEnabled}
      >
        Submit
      </StyledButton>
    </ButtonWrapper>
  </form>
);

export default ReasonForm;
